import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormBase } from '@app/shared/models/form-base.model';
import { CustomFormValidatorHelper } from '@app/shared/services/custom-form-validator';

@Injectable()
export class FormControlService {
  private _defaultValidation = [
    CustomFormValidatorHelper.noWhitespace
  ];

  constructor() {
  }

  toFormGroup(fields: FormBase<any>[]) {
    const group: any = {};

    fields.forEach(field => {
      const fieldValidation = FormControlService.createFieldValidation(field);
      group[field.key] = new FormControl(field.value || '', fieldValidation);
    });
    return new FormGroup(group);
  }

  private static createFieldValidation(field) {
    if (!field.validators) {
      field.validators = [];
    }
    if (!this.isAllowWhiteSpace(field)) {
      field.validators.push(CustomFormValidatorHelper.noWhitespace);
    }
    if (field.required) {
      field.validators.push(Validators.required);
    }
    return field.validators;
  }

  private static isAllowWhiteSpace(field: FormBase<any>) {
    return field.controlType !== 'textbox' && field.controlType !== 'textarea';
  }
}
